import * as React from 'react'

interface Props {
  condition: boolean
}

export const CanView: React.FC<Props> = ({ condition, children }) => {
  return condition ? (children as any) : null
}
